import {Icon} from '@/components/atoms'
import {UserAvatarButton} from '@/components/molecules'

export default function Header({logo, title, ...props}) {
  return (
    <header
      data-testid="header"
      className="min-w-screen flex h-16 items-center justify-between bg-neutral-800 px-6 text-white"
    >
      <div data-testid="header-logo" className="flex h-auto flex-1">
        <img src={logo} alt="Pepsico logo" className="w-28" />
      </div>
      <div data-testid="header-title" className="flex flex-1 items-center gap-2 text-base font-bold text-zinc-50">
        <Icon icon="mediation" style={{fontSize: '1rem'}} /> {title}
      </div>
      <div data-testid="header-user" className="flex w-auto items-center justify-end">
        {props.children && (
          <div data-testid="header-extra-icons" className="mr-4 flex flex-1 items-center">
            {props.children}
          </div>
        )}
        <UserAvatarButton />
      </div>
    </header>
  )
}